import React from 'react';
import { GrFormPrevious, GrFormNext } from 'react-icons/gr';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPrev, onNext, onPageChange }) => {
    const safeTotalPages = Math.max(totalPages || 1, 1);
    const safeCurrentPage = Math.min(Math.max(currentPage || 1, 1), safeTotalPages);
    const pageItems = buildPageItems(safeCurrentPage, safeTotalPages);

    const goToPage = (targetPage) => {
        if (targetPage < 1 || targetPage > safeTotalPages || targetPage === safeCurrentPage) return;

        if (typeof onPageChange === "function") {
            onPageChange(targetPage);
            return;
        }

        // Backward-compatible fallback for old call sites that only pass onPrev/onNext.
        const step = targetPage - safeCurrentPage;
        if (step > 0 && typeof onNext === "function") {
            for (let i = 0; i < step; i += 1) onNext();
        } else if (step < 0 && typeof onPrev === "function") {
            for (let i = 0; i < Math.abs(step); i += 1) onPrev();
        }
    };

    return (
        <div className='pagination-wrapper'>
            <div className="custom-pagination">
                <button
                    className="custom-pagination-btn"
                    onClick={() => goToPage(safeCurrentPage - 1)}
                    disabled={safeCurrentPage === 1}
                    aria-label="Trang trước"
                    title="Trang trước"
                >
                    <GrFormPrevious className="custom-pagination-icon" />
                </button>

                <div className="custom-pagination-pages" aria-label="Danh sách trang">
                    {pageItems.map((item, index) => (
                        item === "..." ? (
                            <span key={`ellipsis-${index}`} className="custom-pagination-ellipsis">...</span>
                        ) : (
                            <button
                                key={item}
                                className={`custom-pagination-page-btn ${item === safeCurrentPage ? "is-active" : ""}`}
                                onClick={() => goToPage(item)}
                                aria-label={`Trang ${item}`}
                                aria-current={item === safeCurrentPage ? "page" : undefined}
                            >
                                {item}
                            </button>
                        )
                    ))}
                </div>

                <button
                    className="custom-pagination-btn"
                    onClick={() => goToPage(safeCurrentPage + 1)}
                    disabled={safeCurrentPage === safeTotalPages}
                    aria-label="Trang sau"
                    title="Trang sau"
                >
                    <GrFormNext className="custom-pagination-icon" />
                </button>
            </div>
        </div>
    );
};

const buildPageItems = (current, total) => {
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }

    if (current <= 4) {
        return [1, 2, 3, 4, 5, "...", total];
    }

    if (current >= total - 3) {
        return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [1, "...", current - 1, current, current + 1, "...", total];
};

export default Pagination;
